export enum RecognitionActionTypes {
  GET_RECEIVED_RECOGNITIONS = "@@RECOGNITION/GET_RECEIVED_RECOGNITIONS",
  GET_RECEIVED_RECOGNITIONS_SUCCESS = "@@RECOGNITION/GET_RECEIVED_RECOGNITIONS_SUCCESS",
  GET_RECEIVED_RECOGNITIONS_FAILURE = "@@RECOGNITION/GET_RECEIVED_RECOGNITIONS_FAILURE",

  GET_SENT_RECOGNITIONS = "@@RECOGNITION/GET_SENT_RECOGNITIONS",
  GET_SENT_RECOGNITIONS_SUCCESS = "@@RECOGNITION/GET_SENT_RECOGNITIONS_SUCCESS",
  GET_SENT_RECOGNITIONS_FAILURE = "@@RECOGNITION/GET_SENT_RECOGNITIONS_FAILURE",

  GET_REVIEW_RECOGNITIONS = "@@RECOGNITION/GET_REVIEW_RECOGNITIONS",
  GET_REVIEW_RECOGNITIONS_SUCCESS = "@@RECOGNITION/GET_REVIEW_RECOGNITIONS_SUCCESS",
  GET_REVIEW_RECOGNITIONS_FAILURE = "@@RECOGNITION/GET_REVIEW_RECOGNITIONS_FAILURE",

  GET_RECOGNITION = "@@RECOGNITION/GET_RECOGNITION",
  GET_RECOGNITION_SUCCESS = "@@RECOGNITION/GET_RECOGNITION_SUCCESS",
  GET_RECOGNITION_FAILURE = "@@RECOGNITION/GET_RECOGNITION_FAILURE",

  CREATE_RECOGNITION = "@@RECOGNITION/CREATE_RECOGNITION",
  CREATE_RECOGNITION_SUCCESS = "@@RECOGNITION/CREATE_RECOGNITION_SUCCESS",
  CREATE_RECOGNITION_FAILURE = "@@RECOGNITION/CREATE_RECOGNITION_FAILURE",

  UPDATE_RECOGNITION = "@@RECOGNITION/UPDATE_RECOGNITION",
  UPDATE_RECOGNITION_SUCCESS = "@@RECOGNITION/UPDATE_RECOGNITION_SUCCESS",
  UPDATE_RECOGNITION_FAILURE = "@@RECOGNITION/UPDATE_RECOGNITION_FAILURE",

  DELETE_RECOGNITION = "@@RECOGNITION/DELETE_RECOGNITION",
  DELETE_RECOGNITION_SUCCESS = "@@RECOGNITION/DELETE_RECOGNITION_SUCCESS",
  DELETE_RECOGNITION_FAILURE = "@@RECOGNITION/DELETE_RECOGNITION_FAILURE",

  GET_CORE_VALUES = "@@RECOGNITION/GET_CORE_VALUES",
  GET_CORE_VALUES_SUCCESS = "@@RECOGNITION/GET_CORE_VALUES_SUCCESS",
  GET_CORE_VALUES_FAILURE = "@@RECOGNITION/GET_CORE_VALUES_FAILURE",

  BULK_APPROVE_RECOGNITIONS = "@@RECOGNITION/BULK_APPROVE_RECOGNITIONS",
  BULK_APPROVE_RECOGNITIONS_SUCCESS = "@@RECOGNITION/BULK_APPROVE_RECOGNITIONS_SUCCESS",
  BULK_APPROVE_RECOGNITIONS_FAILURE = "@@RECOGNITION/BULK_APPROVE_RECOGNITIONS_FAILURE",

  GET_PENDING_COUNT = "@@RECOGNITION/GET_PENDING_COUNT",
  GET_PENDING_COUNT_SUCCESS = "@@RECOGNITION/GET_PENDING_COUNT_SUCCESS",
  GET_PENDING_COUNT_FAILURE = "@@RECOGNITION/GET_PENDING_COUNT_FAILURE",

  // page-header-promotion-plan.md: the page header's combined received+sent count badge.
  GET_RECOGNITION_COUNTS = "@@RECOGNITION/GET_RECOGNITION_COUNTS",
  GET_RECOGNITION_COUNTS_SUCCESS = "@@RECOGNITION/GET_RECOGNITION_COUNTS_SUCCESS",
  GET_RECOGNITION_COUNTS_FAILURE = "@@RECOGNITION/GET_RECOGNITION_COUNTS_FAILURE",

  CLEAR_RECOGNITIONS = "@@RECOGNITION/CLEAR_RECOGNITIONS",
  CLEAR_CORE_VALUES = "@@RECOGNITION/CLEAR_CORE_VALUES",
  CLEAR_REVIEW_RECOGNITIONS = "@@RECOGNITION/CLEAR_REVIEW_RECOGNITIONS",

  SET_RECEIVED_FILTER = "@@RECOGNITION/SET_RECEIVED_FILTER",
  SET_SENT_FILTER = "@@RECOGNITION/SET_SENT_FILTER",
  SET_REVIEW_FILTER = "@@RECOGNITION/SET_REVIEW_FILTER",
}
